// Route path constants
export const PATHS = {
  // Public routes
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  VERIFY_2FA_CODE: "/verify-2FA-code",
  ROOT: "/",

  // Protected routes
  DASHBOARD: "/dashboard",
  COMPONENTS: "/components",
  PROFILE: "/profile",
  SETTINGS: "/settings",
  CALL_FOR_HELP: "/call-for-help",
  CHANGE_PASSWORD: "/change-password",
  USER_LIST: "/user-list",
  MANAGE_USER: "/user-management/user",
  ROLES_PERMISSIONS: "/user-management/roles-permissions",
  COMPANY_LIST: "/companies",
  COMPANY_SETUP: "/company-setup",
  ORGANIZATION: "/organization",
  ONBOARD: "/onboard",
  MORE_SOLUTIONS: "/more-solutions",
  ACTIVITY_LOG: "/activity-log",
  SURVEYS: "/surveys",
  SURVEY_LIBRARY: "/survey-library",
  QUESTION_LIBRARY: "/question-library",
  SURVEY_RESPONSES: "/survey-responses",
  RESPONSES_DETAIL: "/survey-responses/detail/:responseId",
  CREATE_NEW_SURVEY: "/survey-library/create",
  EDIT_SURVEY: "/survey-library/edit/:surveyId",
  TAKE_SURVEY: "/survey-library/take/:surveyId",

  ESG_TARGETS: "/esg/targets",

  ANALYTICS_DASHBOARD: "/analytics/dashboard",
  ESG_TARGETS_SUMMARY: "/esg/targets/summary",
  ESG_REPORT: "/esg/report/:framework/:stepId",
  ESG_REPORT_PREVIEW: "/esg/report-preview",
  ESG_REPORT_PREVIEW_LIST: "/esg/report-preview/list",
  ESG_INVITE_ACCEPT: "/esg/invite/accept",
  ESG_FRAMEWORKS: "/esg/frameworks",
  ESG_MASTER_DATA: "/esg/master-data",
  ESG_MASTER_DATA_ASSIGN: "/esg/master-data/assign",

  DATA_ENTRY: "/data-entry",
  DATA_ENTRY_OVERVIEW: "/data-entry/overview",
  DATA_ENTRY_CONSOLIDATED: "/data-entry/consolidated",
  DATA_ENTRY_DASHBOARD: "/data-entry/dashboard",
  TARGET_SETUP: "/target-setup",
  TARGET_SETUP_OVERVIEW: "/target-setup/overview",

  ESG_REPORTING_BOUNDARY: "/esg/reporting-boundary",
  ESG_REPORTING_BOUNDARY_ADD: "/esg/reporting-boundary/add",
  ESG_REPORTING_BOUNDARY_EDIT: "/esg/reporting-boundary/edit/:reportingYearId",

  SURVEY_TAKE: "/surveys/take",
  SURVEY_RESPONSE_DETAIL: "/surveys/responses/:responseId",
  STANDARD_SURVEY_NEW: "/surveys/standard/new",
  STANDARD_SURVEY_EDIT: "/surveys/standard/:surveyId",
  CUSTOM_SURVEY_NEW: "/surveys/custom/new",
  CUSTOM_SURVEY_EDIT: "/surveys/custom/:surveyId",
  NOTIFICATIONS: "/notifications",

  CARBON_DASHBOARD: "/carbon/dashboard",
  CARBON_TARGETS: "/carbon/targets",
  // CARBON_BANK_SUBMISSIONS: "/carbon/bank/submissions",
  CARBON_TARGETS_NEW: "/carbon/targets/new",
  CARBON_TARGETS_EDIT: "/carbon/targets/:id",
  CARBON_SUBMISSIONS: "/carbon/submissions",
  CARBON_SUBMISSIONS_EDIT: "/carbon/submissions/:id",
  CARBON_SURVEYS: "/carbon/surveys",
  CARBON_SURVEYS_CREATE: "/carbon/surveys/new",
  CARBON_SURVEYS_EDIT: "/carbon/surveys/:id",

  BILL_OCR: "/bill-ocr",
  G_Element: "/g-element",

  CUSTOM_FRAMEWORK_LIST: "/custom-frameworks",
  CUSTOM_FRAMEWORK_BUILDER: "/custom-frameworks/:id",

  // Fallback
  NOT_FOUND: "*",
};

// Helper to check if path is public
export const isPublicPath = (path) => {
  const publicPaths = [
    PATHS.LOGIN,
    PATHS.REGISTER,
    PATHS.FORGOT_PASSWORD,
    PATHS.RESET_PASSWORD,
    PATHS.ROOT,
    PATHS.ESG_INVITE_ACCEPT,
  ];
  return publicPaths.includes(path);
};
